'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getSize = require('../../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _sizes = require('../../../constants/sizes');

var _colors = require('../../../constants/colors');

var _layout = require('../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DefaultIcon = function DefaultIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'defs',
            null,
            _react2.default.createElement('path', {
                id: 'a',
                d: 'M0 53h60V0H0z'
            })
        ),
        _react2.default.createElement(
            'g',
            {
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement(
                'mask',
                {
                    id: 'b',
                    fill: '#fff'
                },
                _react2.default.createElement('use', {
                    xlinkHref: '#a'
                })
            ),
            _react2.default.createElement('path', {
                d: 'M7.5 19.499c-3.46 2.01-5.625 5.725-5.625 9.84 0 6.263 5.047 11.357 11.25 11.357s11.25-5.094 11.25-11.357c0-4.58-2.702-8.69-6.883-10.47l-.388-.165-1.838-5.454h-4.278l-1.613 4.886v3.631H7.5V19.5zm5.625 23.09C5.888 42.589 0 36.645 0 29.339c0-5.231 2.997-9.907 7.68-12.06l1.957-5.922h6.972l2.002 5.942c4.655 2.161 7.639 6.841 7.639 12.04 0 7.306-5.887 13.25-13.125 13.25z',
                fill: '#3F5060',
                mask: 'url(#b)'
            }),
            _react2.default.createElement('path', {
                fill: '#A7F2EB',
                mask: 'url(#b)',
                d: 'M12.188 17.982h1.874v-2.84h-1.874z'
            }),
            _react2.default.createElement('path', {
                d: 'M14.063 42.59c-1.551 0-2.813-1.275-2.813-2.84s1.262-2.84 2.813-2.84v1.894a.943.943 0 0 0-.938.946c0 .522.42.946.938.946v1.893zM44.738 40.696h4.278l1.837-5.454.389-.165c4.18-1.779 6.883-5.89 6.883-10.47 0-6.262-5.047-11.357-11.25-11.357s-11.25 5.095-11.25 11.357c0 4.116 2.164 7.83 5.625 9.84V32.18h1.875v3.632l1.613 4.885zm5.621 1.893h-6.972l-1.955-5.922c-4.684-2.152-7.682-6.829-7.682-12.06 0-7.306 5.888-13.25 13.125-13.25S60 17.301 60 24.607c0 5.199-2.984 9.879-7.639 12.04l-2.002 5.942z',
                fill: '#3F5060',
                mask: 'url(#b)'
            }),
            _react2.default.createElement('path', {
                fill: '#A7F2EB',
                mask: 'url(#b)',
                d: 'M45.938 38.804h1.874v-2.84h-1.874z'
            }),
            _react2.default.createElement('path', {
                d: 'M47.813 17.036c-1.551 0-2.813-1.274-2.813-2.84 0-1.565 1.262-2.839 2.813-2.839v1.893a.943.943 0 0 0-.938.946c0 .523.42.947.938.947v1.893zM38.438 53c-5.17 0-9.376-4.246-9.376-9.464V34.13h1.875v9.405c0 4.174 3.365 7.571 7.5 7.571 4.136 0 7.5-3.397 7.5-7.571v-1.893h1.876v1.893c0 5.218-4.206 9.464-9.376 9.464M30.938 20.882h-1.875V9.465c0-4.176-3.365-7.572-7.5-7.572-4.136 0-7.5 3.396-7.5 7.572v3.076h-1.876V9.465C12.188 4.246 16.393 0 21.563 0c5.169 0 9.375 4.246 9.375 9.465v11.417z',
                fill: '#3F5060',
                mask: 'url(#b)'
            }),
            _react2.default.createElement('path', {
                fill: '#00D8C8',
                mask: 'url(#b)',
                d: 'M29.063 24.607h1.875v-1.893h-1.875zM29.063 28.393h1.875V26.5h-1.875zM29.063 32.179h1.875v-1.893h-1.875z'
            }),
            _react2.default.createElement('path', {
                d: 'M46.875 17.036c-4.135 0-7.5 3.396-7.5 7.571s3.365 7.572 7.5 7.572 7.5-3.397 7.5-7.572c0-4.175-3.365-7.571-7.5-7.571m0 17.035c-5.17 0-9.375-4.245-9.375-9.464 0-5.218 4.206-9.464 9.375-9.464 5.17 0 9.375 4.246 9.375 9.464 0 5.219-4.206 9.464-9.375 9.464M13.125 21.768c-4.135 0-7.5 3.397-7.5 7.571 0 4.175 3.365 7.572 7.5 7.572s7.5-3.397 7.5-7.572c0-4.174-3.365-7.571-7.5-7.571m0 17.036c-5.17 0-9.375-4.246-9.375-9.465 0-5.218 4.206-9.464 9.375-9.464 5.17 0 9.375 4.246 9.375 9.464 0 5.219-4.206 9.465-9.375 9.465',
                fill: '#FFCF3F',
                mask: 'url(#b)'
            })
        )
    );
};

DefaultIcon.defaultProps = {
    width: '60',
    height: '53',
    viewBox: '0 0 60 53',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink'
};

var ProfileIcon = function (_React$Component) {
    _inherits(ProfileIcon, _React$Component);

    function ProfileIcon() {
        _classCallCheck(this, ProfileIcon);

        return _possibleConstructorReturn(this, (ProfileIcon.__proto__ || Object.getPrototypeOf(ProfileIcon)).apply(this, arguments));
    }

    _createClass(ProfileIcon, [{
        key: 'render',
        value: function render() {
            var size = this.props.size || _sizes.Sizes.md;
            size = (0, _getSize2.default)(size);
            return _react2.default.createElement(
                _layout2.default,
                this.props,
                _react2.default.createElement(DefaultIcon, { fill: this.props.hover || this.props.active ? _colors.Colors.calmWhite : _colors.Colors.claimBlack, width: size + 'px', height: size + 'px' })
            );
        }
    }]);

    return ProfileIcon;
}(_react2.default.Component);

exports.default = ProfileIcon;